import { render, staticRenderFns } from "./ModalMigrateResellers.vue?vue&type=template&id=7c8892a6"
import script from "./ModalMigrateResellers.vue?vue&type=script&lang=js"
export * from "./ModalMigrateResellers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports